import { useEffect, useState } from 'react';
import { api, Approval, TOOL_LABEL } from '../api';
import { ErrorBox, fmtDate, useAsync } from '../components/ui';

const RISK: Record<string, string> = { external: 'ügyfél felé megy', financial: 'pénzügyi', write_internal: 'belső írás', destructive: 'végleges' };

/** „Teendők és jóváhagyások” – csak akkor látszik, ha van ügynökréteg (R7). A gazda a runtime (felhőben a laier). */
export function InboxPage() {
  const [items, setItems] = useState<Approval[] | null>(null);
  const [notes, setNotes] = useState<Record<string, string>>({});
  const a = useAsync();
  const load = () => a.run(async () => setItems((await api<{ items: Approval[] }>('/agents/approvals')).items));
  useEffect(() => { load(); }, []);
  const decide = async (id: string, decision: 'approve' | 'reject') => {
    if (await a.run(() => api(`/agents/approvals/${id}/decision`, { method: 'POST', body: { decision, note: notes[id] } }))) load();
  };
  return (
    <div>
      <div className="page-head"><h2>Teendők és jóváhagyások</h2><button className="secondary" onClick={load}>Frissítés</button></div>
      <ErrorBox error={a.error} />
      {items?.length === 0 && <p className="muted">Nincs jóváhagyásra váró tétel.</p>}
      {items?.map((x) => (
        <section key={x.id} className="card approval">
          <div className="card-head">
            <h3>{TOOL_LABEL[x.tool] ?? x.tool}</h3>
            <span className={`badge badge-risk-${x.risk}`}>{RISK[x.risk] ?? x.risk}</span>
            <span className="muted">{x.agent_id} · {fmtDate(x.created_at)}</span>
          </div>
          <p><strong>Indoklás:</strong> {x.reason}</p>
          {x.sources.length > 0 && <p className="muted">Források: {x.sources.map((s) => s.label ?? `${s.type}:${s.ref}`).join(', ')}</p>}
          {x.input?.patch ? (
            <table className="list diff"><thead><tr><th>Mező</th><th>Új érték</th></tr></thead><tbody>
              {Object.entries(x.input.patch).map(([k, v]) => <tr key={k}><td>{k}</td><td className="pre">{Array.isArray(v) ? v.join(', ') : typeof v === 'object' ? JSON.stringify(v) : String(v)}</td></tr>)}
            </tbody></table>
          ) : typeof x.input?.text === 'string' ? <blockquote className="pre">{x.input.text}</blockquote>
            : <pre className="input">{JSON.stringify(x.input, null, 2)}</pre>}
          <div className="actions">
            <input placeholder="Megjegyzés (nem kötelező)" value={notes[x.id] ?? ''} onChange={(e) => setNotes({ ...notes, [x.id]: e.target.value })} />
            <button disabled={a.busy} onClick={() => decide(x.id, 'approve')}>Jóváhagyás</button>
            <button disabled={a.busy} className="secondary" onClick={() => decide(x.id, 'reject')}>Elutasítás</button>
          </div>
        </section>
      ))}
    </div>
  );
}
